import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/students-and-classes/students')({
  component: Outlet
})
